module.exports = __webpack_public_path__ + "static/media/botanicalPoppy.f3f0d42b.jpg";